"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSizes = void 0;
exports.fontSizes = [12, 14, 16, 20, 24, 32, 40, 48, 52, 64].map(n => n + 'px');
//# sourceMappingURL=fonts.js.map